import { defineStore, getActivePinia } from 'pinia';

export function disposeAllStores(): void {
  const activepinia = getActivePinia();
  if (activepinia) {
    Object.entries(activepinia.state.value).forEach(([storeName, state]) => {
      const storeDefinition = defineStore(storeName, state);
      const store = storeDefinition(activepinia);
      store.$dispose();
    });
  }
}
